import moment, { min } from "moment";
import { Dialog } from "@mui/material";
import { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TopBar } from "../components/topBar";
import Snackbar from "@mui/material/Snackbar";
import Button from "@mui/material/Button";
import "swiper/css";
import share from "../assets/icons/share.svg";
import React from "react";
import reviewImage from "../assets/icons/reviewImage.svg";
import { GoodStatus } from "../gql/graphql";
import {
  GetCorporation,
  GetCorporationInput,
  useGetCorporation,
} from "../hooks/useGetCorporation";
import { CorpThumbnails } from "../components/corp-Thumbnails";
import { data } from "jquery";
import {
  GetCorporationCategory,
  GetCorporationCategoryInput,
  useGetCorporationCategory,
} from "../hooks/useGetCorporationCategory";
import { useMe } from "../hooks/useME";
import download from "../assets/icons/download.svg";
import { CouponStatus, UserCouponStatus } from "../constants/props";
import {
  CrUserCouponMutation,
  useCrUserCoupon,
} from "../hooks/useCrUserCoupon";
import { isLoggedInVar } from "../apollo";
import { AlertComponent } from "../components/alert";
export interface State {
  open: boolean;
}

export const GoodCoporation = () => {
  const params = useParams();
  const [tab, setTab] = useState(0);
  const [photo, setPhoto] = React.useState("");
  const [OpenPhoto, setOpenPhoto] = React.useState(false);
  const { data: me } = useMe();
  const [posters, setPosters] = useState<
    GetCorporation["getCorporation"]["corporation"]["goods"][0]["goodPosters"]
  >([]);
  const [selectedCategory, setSelectedCategory] = useState<string>("전체");
  const [categories, setCategories] = useState<
    GetCorporationCategory["getCorporationCategory"]["subCategories"]
  >([]);
  const [scrollOver, setScrollOver] = useState<boolean>(false);
  const [scrollOverCategory, setScrollOverCategory] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertText, setAlertText] = useState<string | undefined>("");
  const [isReceiveCoupon, setIsReceiveCoupon] = useState<boolean>(false);
  const [filteredData, setFilteredData] = useState<
    GetCorporation["getCorporation"]["corporation"]["goods"]
  >([]);
  const [initialData, setInitialData] = useState<
    GetCorporation["getCorporation"]["corporation"]["goods"]
  >([]);
  const [goods, setGoods] = useState<
    GetCorporation["getCorporation"]["corporation"]["goods"]
  >([]);
  const closeAlert = () => {
    setAlertOpen(false);
    if (alertText === "로그인이 필요합니다. <br/> 로그인 하시겠습니까?") {
      navigate("/login");
    } else if (alertText === "잘못된 경로입니다.") {
      navigate(-1);
    } else {
      setAlertOpen(true);
      window.location.reload();
    }
  };

  const onGetCorporationCategoryCompleted = (data: GetCorporationCategory) => {
    const {
      getCorporationCategory: { ok, err, subCategories },
    } = data;
    if (ok && subCategories) {
      setCategories(subCategories);
    }
  };
  const [getCorporationCategory, { data: getCorporationCategoryData }] =
    useGetCorporationCategory(onGetCorporationCategoryCompleted);
  const getCorporationCategoryHandler = () => {
    const input: GetCorporationCategoryInput = {
      corporationId: Number(params.key),
    };
    getCorporationCategory({ variables: { input } });
  };
  // getCorporation
  const onGetCompleted = (data: GetCorporation) => {
    const {
      getCorporation: { ok, err, corporation },
    } = data;
    console.log(data);
    if (ok && corporation) {
      // 5개만 뽑기
      const posters = corporation.goods
        .slice(0, 5)
        .map((good) => good.goodPosters)
        .flat();
      setPosters(posters);
      setGoods(corporation.goods);
      setInitialData(corporation.goods);
      setFilteredData(corporation.goods);
      if (corporation.coupons && corporation.coupons.length > 0) {
        setCouponActive(true);
      }
      if (
        corporation.coupons[0] &&
        corporation.coupons[0].userCoupons &&
        corporation.coupons[0].userCoupons.length > 0
      ) {
        setIsReceiveCoupon(true);
      }
    }
  };
  const [getCorporation, { data: getCorporationData }] =
    useGetCorporation(onGetCompleted);
  const getCorporationHandler = () => {
    const input: GetCorporationInput = {
      corporationId: Number(params.key),
      userId: me?.me.id ? Number(me.me.id) : 0,
    };
    getCorporation({ variables: { input } });
  };

  useEffect(() => {
    if (params.key) {
      getCorporationHandler();
      getCorporationCategoryHandler();
    }
  }, [params.key]);
  // snack bar
  const [state, setState] = useState<State>({
    open: false,
  });
  const { open } = state;
  const [snackMessage, setSnackMessage] = useState<string>(
    "클립보드에 URL이 복사되었습니다."
  );
  const handleClick = () => {
    setState({ open: true });
  };

  const handleClose = () => {
    setState({ ...state, open: false });
  };
  const snacks = (
    <React.Fragment>
      <Button onClick={handleClose}>닫기</Button>
    </React.Fragment>
  );

  // 쿠폰
  const [couponActive, setCouponActive] = useState<boolean>(false);
  const navigate = useNavigate();

  //  copy url
  const CopyUrlToClipboard = () => {
    var dummy = document.createElement("input");
    var text = window.location.href;

    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    setSnackMessage("클립보드에 URL이 복사되었습니다.");
    handleClick();
  };

  useLayoutEffect(() => {
    if (!Number(params.key)) {
      setAlertText("잘못된 경로 입니다.");
      setAlertOpen(true);
    }
    var el = document.querySelector(".scroll-smooth");
    // if (el) el.scrollTo(0, 0);
    el?.addEventListener("scroll", () => {
      if (el?.scrollTop && el?.scrollTop > 100) {
        setScrollOver(true);
      } else {
        setScrollOver(false);
      }
      if (el?.scrollTop && el?.scrollTop > 340) {
        setScrollOverCategory(true);
      } else {
        setScrollOverCategory(false);
      }
    });
  }, []);

  useEffect(() => {
    // "전체" 카테고리가 선택된 경우, 필터링 없이 원본 데이터를 그대로 보여줍니다.
    if (selectedCategory === "전체") {
      setFilteredData(initialData);
      return;
    }

    // 선택된 카테고리에 해당하는 거래처만 필터링합니다.
    const newFilteredData = initialData.filter(
      (good) =>
        // corporation의 mainCategories 배열 안에 선택된 카테고리 이름이 있는지 확인합니다.
        good.subCategory?.name === selectedCategory
    );

    setFilteredData(newFilteredData);
  }, [selectedCategory, initialData]);

  //  쿠폰 발급
  const onCrUserCouponCompleted = (data: CrUserCouponMutation) => {
    if (data.crUserCoupon.ok) {
      setSnackMessage("쿠폰이 발급되었습니다.");
      handleClick();
      getCorporationHandler();
    }
  };
  const [createCoupon, { loading: createCouponLoading }] = useCrUserCoupon(
    onCrUserCouponCompleted
  );

  const createCouponHandler = (couponId: any) => {
    createCoupon({
      variables: {
        input: {
          couponId: Number(couponId),
          userId: me?.me.id ? Number(me.me.id) : 0,
        },
      },
    });
  };
  return (
    <div
      className={`wrap max-w-screen-break mx-auto w-full h-full overflow-auto removeScroll scroll-smooth `}
    >
      <div
        className={`header absolute top-0 left-0 w-full z-20 transition ${
          scrollOver ? "bg-white shadow" : "transparent"
        } `}
      >
        <div>
          <TopBar
            arrow={true}
            home={true}
            shop={true}
            shopColor={"mainIcon"}
            backColor={"transparent"}
            homeColor={"#00b0eb"}
            arrowColor={"#00b0eb"}
          />
        </div>
      </div>
      <main className="max-w-screen-break relative z-10">
        <div className="headInfo">
          <div className="imgBox relative max-w-screen-fit mx-auto">
            <CorpThumbnails posters={posters}></CorpThumbnails>
          </div>
          <div className="infoBox relative pt-4 max-w-screen-fit mx-auto">
            <div className="px-4">
              <div className="text-xl font-bold leading-4 break:text-large  flex flex-wrap items-center justify-between pb-2">
                <p>
                  <span className="">
                    {getCorporationData?.getCorporation.corporation?.name}
                  </span>
                </p>
                <div className="flex flex-wrap items-center gap-x-2">
                  <button
                    onClick={() => {
                      navigate(`/coporation/${params.key}/info`);
                    }}
                    className="text-xs rounded-full bg-block px-2 py-1 font-normal "
                  >
                    매장정보ㆍ원산지 표시
                  </button>
                  <button onClick={CopyUrlToClipboard}>
                    <img src={share} alt="공유하기" />
                  </button>
                </div>
              </div>
              <div className="py-2">
                <p className="max-h-12 text-standard break:text-large text-grayFont ellipsis2 overflow-hidden">
                  {getCorporationData?.getCorporation.corporation?.address}
                </p>
              </div>
              {/* 쿠폰 component */}
              <div className="pb-4">
                {couponActive && (
                  <button
                    disabled={isReceiveCoupon}
                    onClick={() => {
                      if (!isLoggedInVar()) {
                        setAlertText(
                          "로그인이 필요합니다. <br/> 로그인 하시겠습니까?"
                        );
                        setAlertOpen(true);
                        return;
                      }
                      if (
                        getCorporationData?.getCorporation.corporation
                          ?.coupons[0]?.status === CouponStatus.ACTIVE
                      ) {
                        createCouponHandler(
                          getCorporationData?.getCorporation.corporation
                            ?.coupons[0]?.id
                        );
                      }
                    }}
                    className={`isCoupon w-full  rounded-full text-left flex justify-between px-4 ${
                      isReceiveCoupon ? "bg-block" : "bg-mainIcon"
                    }`}
                  >
                    <p className="text-white text-sm font-bold  py-1">
                      <span
                        className={`${
                          isReceiveCoupon ? "text-white" : "text-pointIcon"
                        }`}
                      >
                        {
                          getCorporationData?.getCorporation.corporation
                            ?.coupons[0]?.discountPrice
                        }
                        원
                      </span>{" "}
                      할인 쿠폰 받기
                    </p>
                    <img src={download} alt="쿠폰받기" />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="bodyInfo border-block border-t-4 mt-4">
          {/* 카테고리 */}
          <div
            className={`bg-white w-full  sticky top-12 left-0 z-10 px-4 py-4 ${
              scrollOverCategory && "shadow"
            }`}
          >
            <div className="overflow-x-auto removeScroll flex gap-x-3">
              {categories.map((category) => (
                <button
                  onClick={() => {
                    if (category.name === selectedCategory) {
                      setSelectedCategory("전체");
                    } else {
                      setSelectedCategory(category.name);
                    }
                  }}
                  key={`category-${category.id}`}
                  className={`${
                    selectedCategory === category.name
                      ? "text-mainIcon border-mainIcon"
                      : "text-grayFont border-btnDarkLine"
                  }  border rounded-full px-2 py-1 whitespace-nowrap flex-shrink-0 min-w-[48px]`}
                >
                  {category.name}
                </button>
              ))}
            </div>
          </div>

          <div id="detail" className="pb-4">
            <div className="pt-4 menuList px-4">
              {/* 카테고리 박스 , id는 category이름 */}
              <div id="Category" className="byCategory">
                <p className="text-xl font-bold pb-4">{selectedCategory}</p>
                {/* 상품 Box */}
                {filteredData.map((good) => (
                  <div
                    key={`goods-${good.id}`}
                    onClick={() => {
                      if (good.status === GoodStatus.GoodSales) {
                        navigate(`/detail/${good.id}`);
                      }
                    }}
                    className="goodListCard py-2 border-t-[1px] flex flex-wrap gap-x-2 relative"
                  >
                    {/* 상품 판매 중 아닐때 */}
                    <div
                      className={`absolute top-0 left-0 w-full h-full bg-black bg-opacity-30 z-[1] flex items-center justify-center ${
                        good.status === GoodStatus.GoodSales ? "hidden" : "flex"
                      }`}
                    >
                      <p className="text-white text-sm">판매 준비중</p>
                    </div>
                    {/* 상품 내용 */}
                    <div className="flex flex-col flex-1 gap-1">
                      <p className="text-lg font-bold">{good.title}</p>
                      <p className="text-sm text-grayFont">{good.summary}</p>
                      <p className="font-bold pt-1">{good.price} 원</p>
                      <div className="flex gap-x-3 items-center">
                        <span className="text-[#575757] text-xs">
                          <img
                            src={reviewImage}
                            className="inline-block mr-1"
                          />
                          {/* 리뷰 두 자릿수로 표시 */}
                          {good.goodReviews.length}
                        </span>
                      </div>
                    </div>
                    {/* 상품 이미지 */}
                    <div className="w-1/3 aspect-[1/1] rounded-lg overflow-hidden">
                      <img
                        src={good.goodPosters[0]?.upload?.url || ""}
                        alt="상품 이미지"
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="px-4 py-5 bg-bg">
            <div className="text-sm py-2">
              <p className="break-words">
                ※ 메뉴 사진은 연출된 이미지로 실제 조리된 음식과 다를 수
                있습니다.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Dialog
        open={OpenPhoto}
        onClose={() => {
          setOpenPhoto(false);
        }}
      >
        <div className="w-full max-w-[320px] px-2 transform">
          <img
            src={photo}
            alt="사진 확대"
            className="w-full h-full object-fill"
          />
        </div>
      </Dialog>
      {/* 클립보드 복사 알림 */}
      <Snackbar
        open={open}
        autoHideDuration={3000}
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        onClose={handleClose}
        message={snackMessage}
        action={snacks}
      ></Snackbar>
      <Dialog open={alertOpen} onClose={closeAlert}>
        <AlertComponent
          title={`안내`}
          desc={alertText}
          closeFunction={closeAlert}
        ></AlertComponent>
      </Dialog>
    </div>
  );
};
